import {observer} from 'mobx-react-lite'
import React, {useEffect} from 'react'
import {DataObjectId, Hub, noBoardContainerId, Subtask} from 'yougile-model'
import {UiLocationProvider} from '@api/shared/context/ui-location'
import {Sync} from '@client/sync'
import {Sortable} from '@components/common/sortable/sortable'
import {TaskCard} from '@components/task-card'
import {cn} from '@containers/html-utils'
import {canShowTask} from '@extensions/mirrored-tasks/permissions'
import {SubtaskUtil} from '@extensions/subtask-util'
import {taskPhantomObserver} from '@extensions/task-phantom-observer'
import {useStore} from './subtasks-store'

// Подзадачи в правой панели
export const SubtaskTaskList = observer(
  (props: {
    blocks: boolean
    className?: string
    curvedLines?: boolean
    noShadow?: boolean
    noCheckLists?: boolean
    isTaskTemplate?: boolean
  }) => {
    const [state, store] = useStore()

    useEffect(() => {
      store.syncState()
    }, [taskPhantomObserver.modified])

    const box = Sync.getCurrentSandbox()
    const task = box.getHub(store.taskId)
    let boardId: DataObjectId | undefined
    if (task && task.location === noBoardContainerId) {
      const parent = SubtaskUtil.getTopParentTask(task)
      const col = parent && box.getHub(parent.location)
      boardId = col?.location
    } else {
      const col = task && box.getHub(task.location)
      boardId = col?.location
    }

    const taskCard = (task: Hub, placeholder: Subtask | undefined) => (
      <TaskCard
        asSubtask
        noShadow={!props.blocks}
        noCheckLists={props.noCheckLists}
        remove={
          store.canEdit ? () => store.removeSubtasks([task.id]) : undefined
        }
        task={task}
        withLocationTooltip={
          !state.dragState && task.location !== noBoardContainerId
        }
        onAfterTitleUpdate={title => store.onAfterTitleUpdate(task.id, title)}
        onBeforeOpenChat={store.onBeforeOpenChat}
        withBorder
        isParentTaskTemplate={props.isTaskTemplate}
        boardId={boardId}
        placeholder={placeholder}
        noTaskColor
      />
    )

    const components = Object.fromEntries(
      store.subtasksAsHub.map(task => {
        const res = canShowTask(task)

        let placeholder = undefined

        if (!res) {
          const subs = Object.values(
            store.task?.data?.subtaskList?.subtasks || {}
          )
          placeholder = subs.find(s => s.id === task.id)
        }

        return [task.id, taskCard(task, placeholder)]
      })
    )

    return (
      <UiLocationProvider location="subtask-task-list">
        <div className={cn(props.className, 'mb-8')}>
          <Sortable
            onDragChange={store.setDragState}
            components={components}
            onChange={store.setOrder}
            disable={!store.canEdit}
            curvedLines={props.curvedLines}
            lastSubtask={store.subtasks[store.subtasks.length - 1]}
          />
        </div>
      </UiLocationProvider>
    )
  }
)
